<div class="error">
    <h1>ERROR 404 - PAGE NOT FOUND</h1>
</div>